<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center" style="flex-wrap:wrap">
        <!-- <date-time
          :getParams.sync="formData.date"
          :monthToEnd="false"
          :dateMode.sync="dateMode"
          :dataType.sync="dataType"
          supportDatatype
          ref="dataTime"
          defaultDateMode="custom"
          :defaultTime="defaultTime"
          :disableLocalTimeSet="disableLocalTime"
          :disableLocalTime="disableLocalTime"
          paramTimeFormatter="YYYY-MM-DDTZ" /> -->
          <!-- 过滤 -->
          <div class="d-flex align-items-center">
            <a-radio-group v-model="dateMode">
              <a-radio-button v-for="item in timeOpts" :key="item.key" :value="item.key">{{ item.label }}</a-radio-button>
              <custom-date
                :customDate.sync="customDate"
                :time.sync="dateMode"
                :customTimeLabel="customTimeLabel"
                canSelectTodayAfter
                @change="customDateChangeHandle" />
            </a-radio-group>
          </div>
      </div>
      <div class="d-flex flex-fill justify-content-end">
        <div class="d-flex pl-4" style="width: 310px;">
          <div v-if="filterShow">
            {{$t('bill.text_314')}}<span class="primary-color" style="cursor: pointer;" @click="resetFilter">{{$t('bill.text_315')}}</span>
          </div>
          <div class="flex-fill" />
          <div class="primary-color" style="cursor: pointer;" @click="filterToggle">{{filterShow?$t('bill.text_312'):$t('bill.text_313')}}</div>
        </div>
      </div>
    </div>
    <div class="mt-4" v-if="isShowOperationService">
      <span class="label-w">{{ $t('bill.operation_num') }}：</span>
      <a-tooltip>
        <template slot="title">{{ $t('bill.operation_service.tooltip') }}</template>
        <a-input-number
          style="width:150px"
          v-model="formData.operation_num"
          :min="OPERATION_NUM_MIN"
          :max="OPERATION_NUM_MAX"
          @change="operationNumChangeHandle" />
      </a-tooltip> {{ $t('bill.operation_num.unit') }}
      <span class="label-w ml-3">{{ $t('bill.service_period') }}：</span>
      <a-tooltip>
        <template slot="title">{{ $t('bill.operation_service.tooltip') }}</template>
        <a-input-number
          style="width:150px"
          v-model="formData.service_period"
          :min="SERVICE_PERIOD_MIN"
          :max="SERVICE_PERIOD_MAX"
          @change="servicePeriodChangeHandle" />
      </a-tooltip> {{ $t('bill.service_period.unit') }}
    </div>
    <!-- 多次聚合 -->
    <div class="mt-4" :style="{width:filterShow?'calc(100% - 310px)':'100%'}">
      <a-form :form="form" hideRequiredMark layout="inline">
        <!-- 聚合1 -->
        <a-form-item class="mr-3">
          <span class="label-w">{{$t('bill.text_310', [1])}}</span>
          <a-select v-model="formData.group[0]" style="width:150px">
            <a-select-option v-for="item in groupOpts" :key="item.key" :disabled="item.key === formData.group[1] && item.key !== 'tag'">{{item.value}}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 标签1 -->
        <a-form-item class="mr-4 analysis-tag" v-if="formData.group[0] === 'tag'" :label="$t('bill.key')" v-bind="formItemLayout">
          <a-select
            style="width:150px"
            v-decorator="tagDecorator"
            :loading="tagLoading"
            show-search
            :dropdownMatchSelectWidth="false"
            dropdownClassName="dropdown-item-word-wrap"
            @change="handleTagGroupChange">
            <a-select-option v-for="item in tagOpts" :key="item.key" :disabled="item.key === formData.tag_key1">{{item.value}}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 项目标签1 -->
        <a-form-item class="mr-4 analysis-tag" v-if="formData.group[0] === 'project_tag'" :label="$t('bill.key')" v-bind="formItemLayout">
          <a-select
            style="width:150px"
            v-decorator="['project_tag_key', {rules: [{required: true, message: $t('common_605')}]}]"
            :loading="projectTagLoading"
            show-search
            :dropdownMatchSelectWidth="false"
            dropdownClassName="dropdown-item-word-wrap"
            @change="handleProjectTagGroupChange">
            <a-select-option v-for="item in projectTagOpts" :key="item.key" :disabled="item.key === formData.project_tag_key1">{{item.value}}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 聚合2 -->
        <a-form-item v-if="groupCount > 1" class="mr-3">
          {{$t('bill.text_310', [2])}}
          <a-select v-model="formData.group[1]" style="width:150px">
            <a-select-option v-for="item in groupOpts" :key="item.key" :disabled="item.key === formData.group[0] && item.key !== 'tag' && item.key !== 'project_tag'">{{item.value}}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 标签2 -->
        <a-form-item class="mr-3 analysis-tag" v-if="groupCount > 1 && formData.group[1] === 'tag'" :label="$t('bill.key')" v-bind="formItemLayout">
          <a-select
            style="width:150px"
            v-decorator="['tag_key1', {rules: [{required: true, message: $t('common_605')}]}]"
            :loading="tagLoading"
            show-search
            :dropdownMatchSelectWidth="false"
            dropdownClassName="dropdown-item-word-wrap"
            @change="handleTagGroupChange">
            <a-select-option v-for="item in tagOpts" :key="item.key" :disabled="item.key === formData.tag_key">{{item.value}}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 项目标签2 -->
        <a-form-item class="mr-3 analysis-tag" v-if="groupCount > 1 && formData.group[1] === 'project_tag'" :label="$t('bill.key')" v-bind="formItemLayout">
          <a-select
            style="width:150px"
            v-decorator="['project_tag_key1', {rules: [{required: true, message: $t('common_605')}]}]"
            :loading="projectTagLoading"
            show-search
            :dropdownMatchSelectWidth="false"
            dropdownClassName="dropdown-item-word-wrap"
            @change="handleTagGroupChange">
            <a-select-option v-for="item in projectTagOpts" :key="item.key" :disabled="item.key === formData.project_tag_key">{{item.value}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="(formData.group[0] === 'tag' || formData.group[1] === 'tag')">
          {{formData.tag_val_split ? $t('bill.split_chart') : ''}}
          <a-button type="link" @click="showSplitConfig" style="padding: 0">{{splitMessage}}</a-button>
          <a-button v-if="formData.tag_val_split" type="link" @click="splitChange('')">{{$t('common.cancel')}}</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div :style="{paddingRight: `${filterShow?310:0}px`, position: 'relative'}" :class="`mt-3`">
      <analysises-chart ref="analysisesChart" :loading="loading" :formData="formData" :dataList="dataList" :tagGroupParams="tagGroupParams" :projectTagGroupParams="projectTagGroupParams" @exportExcel="exportExcel" />
      <analysises-table
        ref="analysisesTable"
        :formData="formData"
        :dataList="dataList"
        :tagGroupParams="tagGroupParams"
        :projectTagGroupParams="projectTagGroupParams"
        :isGoPage="false"
        @goBillPage="goBillPage" />
      <div v-show="filterShow" class="pl-4" style="width: 310px;position:absolute;right:0;top:0">
        <analysises-filter ref="analysisesFilter" :formData="formData" :showDimensions="showDimensions" />
      </div>
    </div>

  </div>
</template>

<script>
import * as R from 'ramda'
import { PREDICT_ANALYSIS_GROUP_RATE_LIST, ANALYSIS_SPLITS_MAP } from '@Bill/constants'
import currencyRequest from '@Bill/mixins/currencyRequest'
import WindowsMixin from '@/mixins/windows'
import { uuid, mixSortFunc } from '@/utils/utils'
import { groupBy } from '@/utils/group'
import CustomDate from '@/components/DateTime/CustomDate'
import AnalysisesFilter from './analysis/component/AnalysisesFilter'
import AnalysisesTable from './analysis/component/AnalysisesTable'
import AnalysisesChart from './analysis/component/AnalysisesChart'
import AnalysisesMixin from './analysis/mixins/analysises'

export default {
  name: 'PredictAnalysisIndex',
  components: {
    AnalysisesFilter,
    AnalysisesTable,
    AnalysisesChart,
    CustomDate,
  },
  mixins: [WindowsMixin, currencyRequest, AnalysisesMixin],
  props: {
    billShared: Boolean,
    projectShared: Boolean,
    isShowOperationService: Boolean,
    isGoPage: {
      type: Boolean,
      default: true,
    },
    defaultCustomDate: Object,
  },
  data () {
    const { start_date, end_date, tag_key } = this.$route.query
    return {
      loading: false,
      filterShow: true,
      dateMode: '30day',
      dataType: '',
      seriesArr: {
        trend: [],
        usage: [],
        top10: [],
      },
      dataList: [],
      defaultTime: {
        start: start_date ? this.$moment(start_date) : this.$moment().subtract(6, 'month').startOf('month'),
        end: end_date ? this.$moment(end_date) : this.$moment(new Date()).endOf('month').subtract('month', 1).endOf('month'),
      },
      disableLocalTime: !!start_date,
      form: this.$form.createForm(this),
      formData: {
        group: [PREDICT_ANALYSIS_GROUP_RATE_LIST[0].key],
      },
      formItemLayout: {
        wrapperCol: { span: 16 },
        labelCol: { span: 5 },
      },
      tagsGroup: [null, null],
      tagOpts: [],
      projectTagOpts: [],
      tagGroupParams: {},
      projectTagGroupParams: {},
      tagLoading: false,
      projectTagLoading: false,
      tagDecorator: [
        'tag_key',
        {
          initialValue: tag_key || null,
          rules: [
            { required: true, message: this.$t('common_605') },
          ],
        },
      ],
      showDimensions: ['brand', 'account', 'project', 'origin_res_type', 'charge_type'],
      timeOpts: [
        { key: '30day', label: this.$t('bill.predict.future_30day') },
        { key: '90day', label: this.$t('bill.predict.future_90day') },
        { key: '6month', label: this.$t('bill.predict.future_6month') },
        { key: '1year', label: this.$t('bill.predict.future_1year') },
        { key: '2year', label: this.$t('bill.predict.future_2year') },
        { key: '5year', label: this.$t('bill.predict.future_5year') },
      ],
      customDate: this.defaultCustomDate || {},
    }
  },
  computed: {
    groupOpts () {
      const targets = PREDICT_ANALYSIS_GROUP_RATE_LIST.filter(item => {
        if (this.$store.getters.isProjectMode) {
          return item.key !== 'domain'
        }
        const fieldMap = {
          cloudprovider_name: 'cloudprovider',
          owner_name: 'owner',
          linked_name: 'linked',
        }
        const field = fieldMap[item.key] || item.key
        if (!this.$isScopedPolicyMenuHidden(`fee_hidden_items.${field}`)) {
          return item
        }
      })
      const rets = targets.map(item => {
        if (item.t) {
          item.value = this.$t(item.t)
        }
        return item
      })
      return rets
    },
    groupCount () {
      return this.formData.group.length
    },
    splitMessage () {
      return this.formData.tag_val_split ? ANALYSIS_SPLITS_MAP[this.formData.tag_val_split].label : this.$t('bill.split')
    },
  },
  watch: {
    formData: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.fetchData()
        })
      },
    },
    billShared: {
      handler () {
        this.fetchData()
      },
    },
    projectShared () {
      this.fetchData()
    },
    dateMode: {
      immediate: true,
      handler (val) {
        this.updateCustomTimeLabel(val, this.customDate)
        this.fetchData()
      },
    },
  },
  created () {
    this.analysisM = new this.$Manager('predictions/query', 'v1')
  },
  methods: {
    validateForm () {
      return new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          if (!err) {
            resolve(values)
          } else {
            reject(err)
          }
        })
      })
    },
    async fetchData () {
      const { group } = this.formData
      if (group[0] === 'tag' || (this.groupCount > 1 && group[1] === 'tag')) {
        this.fetchTags(group)
        const values = await this.validateForm()
        if ((group[0] === 'tag' && !values.tag_key) || (this.groupCount > 1 && group[1] === 'tag' && !values.tag_key1)) {
          return
        }
        this.tagGroupParams = values
      } else if (group[0] === 'project_tag' || (this.groupCount > 1 && group[1] === 'project_tag')) {
        this.fetchProjectTags(group)
        const values = await this.validateForm()
        if ((group[0] === 'project_tag' && !values.project_tag_key) || (this.groupCount > 1 && group[1] === 'project_tag' && !values.project_tag_key1)) {
          return
        }
        this.projectTagGroupParams = values
      } else {
        this.tagGroupParams = {}
      }
      this.$nextTick(() => {
        this.loading = true
        Promise.all([this._getData()]).then(() => {
          this.loading = false
        })
      })
    },
    genFormDataParams () {
      const params = {}
      R.forEachObjIndexed((value, key) => {
        if (key !== 'date') {
          if (R.is(Array, value)) {
            params[key] = value
          } else if (value) {
            params[key] = value
          }
        }
      }, this.formData)
      delete params.tag
      delete params.tag_key
      delete params.tag_key1
      delete params.project_tag
      delete params.project_tag_key
      delete params.project_tag_key1
      delete params.group
      // 标签聚合时，不出现在group参数中
      // params.group = R.clone(params.group).filter(key => key !== 'tag')
      // 标签分隔
      if (params.tag_val_split) {
        params.tag_val_split = ANALYSIS_SPLITS_MAP[params.tag_val_split].value
      }
      return params
    },
    genParams () {
      // eslint-disable-next-line camelcase
      // const queryType = 'expense_trend'
      const { group } = this.formData
      // const { data_type } = date
      const formDataParams = this.genFormDataParams()
      const tagParams = {}
      const projectTagParams = {}
      let metadataIndex = 0
      let metadataIndex1 = 0
      for (const key in this.formData.tag) {
        if (key === 'without_bill_tags') {
          tagParams.without_bill_tags = true
        } else if (key === 'with_bill_tags') {
          tagParams.with_bill_tags = true
        } else {
          tagParams[`tags.${metadataIndex}.key`] = key
          if (this.formData.tag[key]) {
            tagParams[`tags.${metadataIndex}.value`] = this.formData.tag[key]
          }
          metadataIndex++
        }
      }
      for (const key in this.formData.project_tag) {
        if (key === 'without_project_tags') {
          projectTagParams.without_project_tags = true
        } else if (key === 'with_project_tags') {
          projectTagParams.with_project_tags = true
        } else {
          if (R.is(Array, this.formData.project_tag[key]) && this.formData.project_tag[key].length) {
            this.formData.project_tag[key].map(value => {
              projectTagParams[`project_tags.0.${metadataIndex1}.key`] = key
              projectTagParams[`project_tags.0.${metadataIndex1}.value`] = value
              metadataIndex1++
            })
          } else {
            projectTagParams[`project_tags.0.${metadataIndex1}.key`] = key
            metadataIndex1++
          }
        }
      }
      const tagFixList = ['bill', 'project']
      tagFixList.map(key => {
        if (tagParams[`without_${key}_tags`] && tagParams[`with_${key}_tags`]) {
          delete tagParams[`without_${key}_tags`]
          delete tagParams[`with_${key}_tags`]
        }
        if (projectTagParams[`without_${key}_tags`] && projectTagParams[`with_${key}_tags`]) {
          delete projectTagParams[`without_${key}_tags`]
          delete projectTagParams[`with_${key}_tags`]
        }
      })
      // 按标签聚合 参数
      const groupParams = []
      const tagKey = this.form.getFieldValue('tag_key')
      const tagKey1 = this.form.getFieldValue('tag_key1')
      const projectTagKey = this.form.getFieldValue('project_tag_key')
      const projectTagKey1 = this.form.getFieldValue('project_tag_key1')
      for (let i = 0; i < group.length; i++) {
        if (group[i] === 'project_tag') {
          if (i === 0) {
            groupParams[i] = 'project_tag:' + projectTagKey
          } else if (i === 1) {
            groupParams[i] = 'project_tag:' + projectTagKey1
          }
        } else if (group[i] === 'tag') {
          if (i === 0) {
            groupParams[i] = 'tag:' + tagKey
          } else if (i === 1) {
            groupParams[i] = 'tag:' + tagKey1
          }
        } else if (group[i] === 'owner_name') {
          groupParams[i] = 'account'
        } else {
          groupParams[i] = group[i]
        }
      }
      const $t = uuid()
      const groupMap = {
        project: 'tenant_id',
        account: 'account_id',
      }
      const params = {
        $t,
        // query_type: queryType,
        ...this.gerateDateParams(this.dateMode),
        // 'group.0': data_type,
        scope: this.$store.getters.scope,
        admin: this.$store.getters.isAdminMode,
        'group.1': groupMap[groupParams[0]] || groupParams,
        ...formDataParams,
        // ...tagParams,
        // ...projectTagParams,
        ...R.clone(this.currencyParams),
      }
      // if (this.billShared) {
      //   params.is_prepaid_amortizing = true
      // } else {
      //   params.is_prepaid_amortizing = false
      // }
      // if (this.projectShared) {
      //   params.is_project_sharing = true
      // } else {
      //   params.is_project_sharing = false
      // }
      if (!params.filter) {
        params.filter = []
      }
      params.filter = Array.from(new Set(params.filter))
      // 产品过滤
      if (params.spec && params.spec.length) {
        const specs = params.spec.map(key => `'${key}'`)
        params.filter.push(`spec.in(${specs.join(',')})`)
      }
      if (params.financial_unit && params.financial_unit.length) {
        const financial_units = params.financial_unit.map(key => `'${key}'`)
        params.filter.push(`financial_unit.in(${financial_units.join(',')})`)
      }
      // 去掉没有使用的参数
      delete params.operation_num
      delete params.service_period
      delete params.exchanged_currency
      delete params.disable_cost_conversion
      return params
    },
    transParams (params) {
      if (params.domain && params.domain.length) {
        params.domain.map((d, idx) => {
          params[`project_domain_ids.${idx}`] = d
        })
        delete params.domain
      }
      if (params.project && params.project.length) {
        params.project.map((p, idx) => {
          params[`project_ids.${idx}`] = p
        })
        delete params.project
      }
    },
    _getData () {
      const params = this.genParams()
      delete params.spec
      delete params.financial_unit
      this.transParams(params)
      return this.analysisM.list({
        params,
      }).then(({ data: { data } }) => {
        const groupData = groupBy(data, (item) => {
          return item[this.formData.group[0]]
        })
        this.dataList = this.getSortDataBySum(groupData)
      }).catch(error => {
        throw error
      })
    },
    filterToggle () {
      this.filterShow = !this.filterShow
      this.$nextTick(() => {
        if (this.groupCount === 1) {
          this.$refs.analysisesChart.$refs.analysisChart.$refs.chart.echarts.resize()
        }
      })
    },
    async fetchTags (group) {
      const tagKey = this.form.getFieldValue('tag_key')
      const tagKey1 = this.form.getFieldValue('tag_key1')
      if (this.tagOpts.length !== 0) {
        if (group[0] === 'tag' && !tagKey) {
          this.form.setFieldsValue({
            tag_key: this.tagOpts[0].key,
          })
        }
        if (group[1] === 'tag' && !tagKey1) {
          this.form.setFieldsValue({
            tag_key1: this.tagOpts[0].key,
          })
        }
        if ((group[0] === 'tag' && !tagKey) || (group[1] === 'tag' && !tagKey1)) {
          this.handleTagGroupChange()
        }
        return
      }
      this.tagLoading = true
      try {
        const result = await new this.$Manager('res_tag_details', 'v1').list({
          params: {
            ...this.$refs.analysisesFilter.tagParams,
            key_prefix: ['user:', 'ext:'],
            scope: this.$store.getters.scope,
            key_only: true,
          },
        })
        const { data: tagsList = [] } = result.data
        const tagKeys = Array.from(new Set(tagsList.map(item => {
          return item.key
        })))
        const tagOpts = tagKeys.map(item => {
          return {
            key: item,
            value: this.getTagKey(item),
          }
        })
        tagOpts.sort((a, b) => a.value.localeCompare(b.value))
        this.tagOpts = tagOpts
        if (group[0] === 'tag' && !tagKey) {
          this.form.setFieldsValue({
            tag_key: tagOpts[0] ? tagOpts[0].key : '',
          })
        }
        if (group[1] === 'tag' && !tagKey1) {
          this.form.setFieldsValue({
            tag_key1: tagOpts[0] ? tagOpts[0].key : '',
          })
        }
        if (tagOpts[0] && ((group[0] === 'tag' && !tagKey) || (group[1] === 'tag' && !tagKey1))) {
          this.handleTagGroupChange()
        }
        this.tagLoading = false
      } catch (err) {
        this.tagLoading = false
      }
    },
    async fetchProjectTags (group) {
      const tagKey = this.form.getFieldValue('project_tag_key')
      const tagKey1 = this.form.getFieldValue('project_tag_key1')
      if (this.projectTagOpts.length !== 0) {
        if (group[0] === 'project_tag' && !tagKey) {
          this.form.setFieldsValue({
            project_tag_key: this.projectTagOpts[0].key,
          })
        }
        if (group[1] === 'project_tag' && !tagKey1) {
          this.form.setFieldsValue({
            project_tag_key1: this.projectTagOpts[0].key,
          })
        }
        if ((group[0] === 'project_tag' && !tagKey) || (group[1] === 'project_tag' && !tagKey1)) {
          this.handleProjectTagGroupChange()
        }
        return
      }
      this.projectTagLoading = true
      try {
        const result = await new this.$Manager('project_tag_details', 'v1').list({
          params: {
            ...this.$refs.analysisesFilter.projectTagParams,
            // key_prefix: ['user:', 'ext:'],
            scope: this.$store.getters.scope,
            key_only: true,
          },
        })
        const { data: tagsList = [] } = result.data
        const tagKeys = Array.from(new Set(tagsList.map(item => {
          return item.key
        })))
        const projectTagOpts = tagKeys.map(item => {
          return {
            key: item,
            value: this.getTagKey(item),
          }
        })
        projectTagOpts.sort((a, b) => mixSortFunc((a.value || '').toLowerCase(), (b.value || '').toLowerCase()))
        this.projectTagOpts = projectTagOpts
        if (group[0] === 'project_tag' && !tagKey) {
          this.form.setFieldsValue({
            project_tag_key: projectTagOpts[0] ? projectTagOpts[0].key : '',
          })
        }
        if (group[1] === 'project_tag' && !tagKey1) {
          this.form.setFieldsValue({
            project_tag_key1: projectTagOpts[0] ? projectTagOpts[0].key : '',
          })
        }
        if (projectTagOpts[0] && ((group[0] === 'project_tag' && !tagKey) || (group[1] === 'project_tag' && !tagKey1))) {
          this.handleProjectTagGroupChange()
        }
        this.projectTagLoading = false
      } catch (err) {
        this.projectTagLoading = false
      }
    },
    resetFilter () {
      this.formData = {
        group: this.formData.group,
        platform_brand: [],
        account: [],
        linked_name: [],
        cloudprovider: [],
        region: [],
        project: [],
        domain: [],
        charge_type: undefined,
        resource_type: [],
        spec: [],
        financial_unit: [],
        date: this.formData.date,
        tag: {},
        project_tag: {},
        tag_key: this.formData.tag_key,
        tag_key1: this.formData.tag_key1,
        project_tag_key: this.formData.tag_key,
        project_tag_key1: this.formData.tag_key1,
      }
    },
    goBillPage (params) {
      const originParams = this.genParams()
      // 已选参数
      const { platform_brand, account_id, cloudprovider_id, region_ext_id, domain, project } = originParams
      // 备选参数
      const { options: filterOptions = {} } = this.$refs.analysisesFilter
      const { accounts = [], cloudproviders = [], regions = [], domains = [], projects = [] } = filterOptions
      // 平台
      if (platform_brand && platform_brand.length) {
        originParams.brand = platform_brand
        delete originParams.platform_brand
      }
      const getFilterName = function (list, targetId, idKey = 'item_id', nameKey = 'item_name') {
        const targetList = list.filter(item => item[idKey] === targetId)
        if (!targetList[0]) {
          return null
        }
        const id = targetList[0][idKey] || ''
        const idFirst = id.substr(0, 8)
        let name = targetList[0][nameKey] || ''
        if (name.indexOf(idFirst) > -1) {
          name = name.replace(` (${idFirst})`, '') // 兼容重名后用id区分的资源名 xxx（55sdf48a）
        }
        return name
      }

      const genParam = function (originList, originKey, targetKey, filteredList) {
        if (originList && originList.length) {
          const list = []
          originList.map(id => {
            const name = getFilterName(filteredList, id)
            if (name) {
              if (targetKey === 'account' && id === 'yunion') {
                list.push('OneStack')
              } else {
                list.push(name)
              }
            }
          })
          if (list.length) originParams[targetKey] = list
        }
        if (originKey !== targetKey) delete originParams[originKey]
      }
      genParam(account_id, 'account_id', 'account', accounts)
      genParam(cloudprovider_id, 'cloudprovider_id', 'cloudprovider_name', cloudproviders)
      genParam(region_ext_id, 'region_ext_id', 'region', regions)
      genParam(domain, 'domain', 'domain', domains)
      genParam(project, 'project', 'project', projects)
      const transParams = {}
      const transKeys = ['brand', 'project', 'account', 'region', 'cloudprovider_name', 'domain', 'owner_name', 'linked_name', 'resource_type', 'financial_unit', 'spec']
      transKeys.map(key => {
        if (params[key]) {
          transParams[key] = [params[key]]
        }
      })
      originParams.tag = this.formData.tag || {}
      // 合并filter和table中选择的标签
      const tagAll = this.mergeTag(originParams, params)
      this.$router.push({ name: 'BillMonthlyDetail', params: { ...originParams, ...params, ...transParams, tag: tagAll } })
    },
    mergeTag (param1, param2) {
      const { tag: tag1 = {} } = param1
      const { tag: tag2 = {} } = param2
      const allTag = R.clone(tag1)
      for (const key in tag2) {
        allTag[key] = allTag[key] && !(tag2[key] in allTag[key]) ? allTag[key].concat(tag2[key]) : tag2[key]
      }
      return allTag
    },
    changeGroup () {
      let { group } = this.formData
      if (this.groupCount === 1) {
        // 第二聚合维度默认为资源类型
        if (group[0] !== 'resource_type') {
          const isExist = this.groupOpts?.includes(o => o.key === 'resource_type')
          const type = isExist ? 'resource_type' : this.groupOpts[0]?.key
          group = [group[0], type]
        } else {
          const list = PREDICT_ANALYSIS_GROUP_RATE_LIST
          for (let i = 0; i < list.length; i++) {
            if (group[0] !== list[i].key) {
              group = [group[0], list[i].key]
              break
            }
          }
        }
      } else {
        group = [group[0]]
      }
      this.formData.group = group
    },
    handleTagGroupChange () {
      this.$nextTick(() => {
        this.fetchData()
      })
    },
    handleProjectTagGroupChange () {
      this.$nextTick(() => {
        this.fetchData()
      })
    },
    exportExcel () {
      this.$refs.analysisesTable.download()
    },
    showSplitConfig () {
      this.createDialog('BillAnalysisSetSplitDialog', {
        split: this.formData.tag_val_split,
        splitChange: this.splitChange,
      })
    },
    splitChange (split) {
      if (this.formData.tag_val_split !== split) {
        this.formData.tag_val_split = split
      }
    },
    getSortDataBySum (dataList) {
      const _dataList = R.clone(dataList)
      const { operation_num, service_period } = this.formData

      for (let index = 0; index < dataList.length; index++) {
        const item = _dataList[index]
        const stat_values = item.data.map(obj => {
          obj.date_info = obj[this.dataType]
          obj.prediction = obj.prediction || 0
          if (R.is(Number, operation_num) && R.is(Number, service_period)) {
            if (operation_num > 0 && service_period > 0) {
              obj.stat_value = obj.prediction / operation_num * service_period
            } else {
              obj.stat_value = obj.prediction
            }
          } else {
            obj.stat_value = obj.prediction
          }
          return obj.prediction
        })
        const stat_value_sum = R.sum(stat_values)
        _dataList[index].stat_value_sum = stat_value_sum
      }
      _dataList.sort((a, b) => b.stat_value_sum - a.stat_value_sum)

      return _dataList
    },
    updateCustomTimeLabel (type, date) {
      try {
        if (type === 'custom') {
          const start = this.$moment(date.start).format('YYYY-MM-DD')
          const end = this.$moment(date.end).format('YYYY-MM-DD')
          this.customTimeLabel = ` (${start} - ${end})`
        } else {
          this.customTimeLabel = ''
        }
      } catch (err) {
        this.customTimeLabel = ''
      }
    },
    gerateDateParams (dateMode) {
      const ret = {}
      if (dateMode === '30day') { // 将来
        ret.start_day = parseInt(this.$moment().add(1, 'day').format('YYYYMMDD'))
        ret.end_day = parseInt(this.$moment().add(30, 'day').format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'day'
      } else if (dateMode === '90day') {
        ret.start_day = parseInt(this.$moment().add(1, 'day').format('YYYYMMDD'))
        ret.end_day = parseInt(this.$moment().add(90, 'day').format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'month'
      } else if (dateMode === '6month') {
        ret.start_day = parseInt(this.$moment().add(1, 'month').startOf('month').format('YYYYMMDD'))
        ret.end_day = parseInt(this.$moment().add(6, 'month').endOf('month').format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'month'
      } else if (dateMode === '1year') {
        ret.start_day = parseInt(this.$moment().add(1, 'year').startOf('year').format('YYYYMMDD'))
        ret.end_day = parseInt(this.$moment().add(1, 'year').endOf('year').format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'month'
      } else if (dateMode === '2year') {
        ret.start_day = parseInt(this.$moment().add(1, 'year').startOf('year').format('YYYYMMDD'))
        ret.end_day = parseInt(this.$moment().add(2, 'year').endOf('year').format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'month'
      } else if (dateMode === '5year') {
        ret.start_day = parseInt(this.$moment().add(1, 'year').startOf('year').format('YYYYMMDD'))
        ret.end_day = parseInt(this.$moment().add(5, 'year').endOf('year').format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'month'
      } else if (dateMode === 'custom') {
        const { start, end } = this.customDate
        ret.start_day = parseInt(start.format('YYYYMMDD'))
        ret.end_day = parseInt(end.format('YYYYMMDD'))
        ret['group.0'] = this.predictGroupType || 'month'
        const diffMonth = this.$moment(end).add(1, 'seconds').diff(start, 'months') // 相差几个月
        if (diffMonth <= 1) ret['group.0'] = this.predictGroupType || 'day'
      }
      this.dataType = ret['group.0']
      return ret
    },
    customDateChangeHandle (customDate) {
      this.updateCustomTimeLabel(this.dateMode, customDate)
      this.fetchData()
    },
  },
}
</script>
<style lang="less">
.analysis-tag-dropdown {
  max-width: 400px;
}
.analysis-tag > .ant-form-item-label > .ant-form-item-required {
  color: #000000a6;
}
.label-w {
  display: inline-block;
  width: 86px;
}
</style>
